import { Business } from './business';

export enum UserType {
  SystemAdmin = 'SYSTEM_ADMIN',
  User = 'USER',
  Temporary = 'TEMP',

  // for service provider
  Admin = 'ADMIN',
  Operator = 'OPERATOR',
}

export enum UserStatus {
  Pending = 'PENDING_ACTIVATION',
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
}

export enum PaymentStatus {
  OK = 'OK',
  Pastdue = 'Pastdue', // have at least 1 subscription pastdue
}

export enum UserRole {
  // SystemAdminRole
  UserAdmin = 'USER_ADMIN',
  ServiceProviderAdmin = 'SP_ADMIN',
  CommentAdmin = 'COMMENT_ADMIN',

  SQUAREPING = 'SQUAREPING',
  PINGPAD = 'PINGPAD',
  PINGREADY = 'PINGREADY',

  // UserRole
  GroupAdmin = 'GROUP_ADMIN',

  // Service Provider OperatorRole
  Booking = 'BOOKING_ADMIN',
  Order = 'ORDER_ADMIN',
}

export enum UserSessionType {
  Unknown = 'unknown',
  SircleApp = 'sircle-app',
  Web = 'web',
  WatchApp = 'watch-app',
}

export enum UserDeletionReason {
  NewRegistrationRequested = 'SYS_NEW_REG',
  UpdatedByAdmin = 'ADMIN_UPDATED',
  UserRequested = 'USER_REQUESTED',
}

export enum UserBlockReason {
  NotPurchased = 'not-purchased',
}

export enum RegistrationType {
  Phone = 'phone',
  Email = 'email',
  Device = 'device',
}

export enum ServiceType {
  PINGPAD = 'PINGPAD',
  PINGPAD_APP = 'PINGPAD_APP',
  PING = 'PING',
  PINGREADY = 'PINGREADY',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN', // for using admin page.
  PINGPAD_MANAGEMENT = 'PINGPAD_MANAGEMENT',
}

export interface GroupPermission {
  groupId: string;
  groupName: string;
  groupType: string;
  contentPermissions: string[];
}

export interface User {
  _id: string;

  status: UserStatus;
  type: UserType;
  roles: UserRole[];

  registrationType?: RegistrationType;
  serviceType: ServiceType;
  //services: ServiceType[]; // list of services used by user ( PINGPAD, PING ... )
  suspendedServices: ServiceType[]; // list of services has been suspended (by admin) for that user

  // profile
  phoneNumber: string;
  phoneNumberCountryCode: string;
  phoneNumberCallingCode: string;
  phoneNumberUserInput: string;
  phoneConfirmed: boolean;
  firstName: string;
  lastName: string;
  businessWebsite?: string;
  businessName?: string;
  businessAddress?: string;
  businessCountry?: string;
  businessLocalLevel1?: string;
  businessLocalLevel2?: string;
  businessPostalCode?: string | number;
  nameConfirmed: boolean;
  email: string;
  emailConfirmed: boolean;
  deviceId?: string;
  avatar: string | null | undefined;
  language: string;

  // parental control
  isPC: boolean;
  pcUserGroup?: string;

  // purchase
  isPremium: boolean;
  premiumPackage?: string;
  isPremiumBlocked?: boolean;
  premiumExpireTime?: Date;
  activeTime?: Date;
  lastLoginTime?: string;
  paymentStatus: PaymentStatus;
  pastDueTime?: Date;

  extensionCount?: number;
  activeExtensionCount?: number;
  // business/family
  activeBusinessCount?: number;
  businesses: Business[];
  families: string[];

  // permissions
  permissions?: GroupPermission[];

  createdTime: Date;
  updatedTime: Date;
}

export type CurrentUser = Omit<User, 'businesses' | 'families'> & {
  businesses: Business[];
  families: any[];
};

export interface UserMetadata {
  owner: string;

  phoneConfirmationToken: string | null;
  phoneConfirmationTokenCreatedTime: Date | null;
  emailConfirmationToken: string | null;
  emailConfirmationTokenCreatedTime: Date | null;

  failedPasswordAttemptCount: number;
  failedPasswordAttemptLastTime: Date | null;
  firebaseVerificationId: string | null | undefined;

  currentAdCredit: number;
  balance: number;

  blockReason?: string;
  deletionReason?: string;

  notifCount: number;
  notifLastBucket: number;

  lastLogin?: number;
  lastLogout?: number;

  createdTime: Date;
  updatedTime: Date;
}
